"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

_vue["default"].use(_vueRouter["default"]);
/**
 * noAuth:true                    不受权限控制的
 * parentPath:'/app'              父级路由
 * hidden: true                   如果hidden:true ，在左侧菜单中不展示此项，非必须，模式是显示
 * redirect: noredirect           如果 `redirect:noredirect` 在面包屑导航中，不会高亮此项且不具备路由功能，非必须
 * name:'router-name'             <keep-alive>需要此配置，必须有 而且是唯一的
 * meta : {
    role: ['admin','editor']     权限控制，可以配置多个，如果什么都没有配，默认所有角色都可见的
    title: 'title'               在菜单,面包屑显示的名称
    icon: 'svg-name'             在菜单中显示的svg图标
    noCache: true                页面是否需要缓存，默认是false
  }
 **/


var _default = new _vueRouter["default"]({
  // mode: 'history', //后端支持可开
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: []
});

exports["default"] = _default;